import React from 'react'
import PageNotFound from '../404/PageNotFound'
import AlertMessage from '../AlertMessage/AlertMessage'
import './Labs.css'
function Labs() {
    return (
        <div>
           <PageNotFound/>
        </div>
    )
}

export default Labs

